import { ReactNode, useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />

      {/* LINE 浮動按鈕 */}
      <a
        href="https://line.me/ti/p/wJ4U8JR3pC"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LINE 諮詢"
        className="fixed bottom-24 right-6 z-50 w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
        style={{ backgroundColor: '#06C755' }}
      >
        <i className="ri-line-fill text-2xl text-white"></i>
      </a>

      {/* 回到頂部懸浮按鈕 */}
      <button
        onClick={scrollToTop}
        aria-label="回到頂部"
        className={`fixed bottom-8 right-6 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-orange-500 text-white shadow-lg transition-all duration-300 hover:bg-orange-600 cursor-pointer whitespace-nowrap ${
          showTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}
